var map = {
	"./apple.svg": "bbfa",
	"./auth-background.png": "6f01",
	"./auth-galeria-pomorska-logo-bg.png": "5d53",
	"./auth-posnania-action.png": "8e53",
	"./auth-posnania-valentines.png": "fbe1",
	"./auth-santa-left-top.png": "a9fe",
	"./avatar-demo-knowledge.png": "7f6e",
	"./avatars/avatar-aica.png": "2dfb",
	"./avatars/avatar-centrum-riviera.png": "a5cf",
	"./avatars/avatar-galeria-pomorska.png": "9b2f",
	"./avatars/avatar-galeria-posnania.png": "b220",
	"./avatars/avatar-hotel-bialy-kamien.png": "0e25",
	"./avatars/avatar-leaf.png": "844c",
	"./avatars/avatar-pasaz-grunwaldzki.svg": "f6d0",
	"./avatars/avatar-posnania-action.png": "9e6f",
	"./avatars/avatar-posnania-valentines.png": "5141",
	"./avatars/avatar-valo-motion.png": "6299",
	"./avatars/avatar.png": "bb20",
	"./avatars/logo-baltycka.png": "390c",
	"./avatars/santa-claus.png": "8a30",
	"./facebook.svg": "282f",
	"./flags/de.png": "64ce",
	"./flags/en.png": "1409",
	"./flags/es.png": "31be",
	"./flags/it.png": "ead4",
	"./flags/pl.png": "98ec",
	"./flags/uk.png": "0e52",
	"./google.svg": "ccc8",
	"./icon-chat.svg": "9d53",
	"./icon-close.svg": "ffed",
	"./icon-gift.svg": "9f9b",
	"./icon-loading.svg": "0830",
	"./logo-baltycka.png": "3c3b",
	"./logo-demo-knowledge.png": "14d0",
	"./logos/logo-aica-hotel.png": "1fb7",
	"./logos/logo-aica.png": "e03c",
	"./logos/logo-amica.png": "163c",
	"./logos/logo-astanet.png": "d451",
	"./logos/logo-baltycka.png": "cfab",
	"./logos/logo-centrum-riviera.svg": "aa3f",
	"./logos/logo-galeria-lodzka.png": "bd8f",
	"./logos/logo-galeria-pomorska.png": "7ef5",
	"./logos/logo-goodfood.png": "f690",
	"./logos/logo-hotel-bialy-kamien.png": "9c28",
	"./logos/logo-lira.png": "af04",
	"./logos/logo-pasaz-grunwaldzki.png": "8fbb",
	"./logos/logo-valo-motion.png": "5890",
	"./mikolaj-auth.png": "511e",
	"./presenter-modal-bg.png": "cb5c",
	"./settings.svg": "1354"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";